import { getConfigWithMetadata } from '@pkgs/api/utils/headers';
import { mapSearchListingsFiltersToSearchFilterRequest } from '@pkgs/api/utils/filters';
import { getErrorResult } from '@pkgs/api/utils/error';
import { type ApiConfig, type ApiResult, type SearchListingsFilters, type SearchListingsOptions } from '@pkgs/api/types';
import { type SearchFilterRequest } from '@pkgs/api/models';
import { listPropertiesForMap, type SearchGeoPointResponse } from '@generated/search-bff';

/**
 * Fetch properties coordinates based on provided filters using the `/api/v2/listing/search/geopoints` endpoint.
 *
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/listings/searchListingsCoordinates Search API Documentation}
 */
export async function searchListingsCoordinates(
  filters: SearchListingsFilters,
  options: SearchListingsOptions,
  apiConfig: ApiConfig,
): Promise<ApiResult<SearchGeoPointResponse, unknown, { appliedFilters: SearchFilterRequest }>> {
  const _apiConfig = getConfigWithMetadata(apiConfig, 'searchListingsCoordinates');
  const appliedFilters = mapSearchListingsFiltersToSearchFilterRequest(filters, options);

  try {
    const data = await listPropertiesForMap(
      appliedFilters,
      options.marketCountryCode ? { marketCountryCode: options.marketCountryCode } : undefined,
      _apiConfig,
    );

    return {
      status: 'success',
      data,
      metadata: { appliedFilters },
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error, { appliedFilters });
  }
}
